module.exports = __webpack_public_path__ + "img/m_logo_white.cabbeb3d.png";